import { useQuery } from '@tanstack/react-query';
import { searchApi } from '~/api/search';
import { getSearchContentsIds } from '~/contentSearchUtils';
import { GET_SELECTED_CONTENTS_QUERY_KEY } from '~/queries/keys';
import {
  COMPARATOR_TYPES,
  SearchHighlightedContentResult,
  mapApiSearchContentResultsFromApiToVm,
} from '~/searchApi';

export const useGetSelectedContents = (
  contents: SearchHighlightedContentResult[] | undefined,
) => {
  const contentIds = getSearchContentsIds(contents);

  return useQuery(
    [GET_SELECTED_CONTENTS_QUERY_KEY, contentIds],
    () =>
      searchApi
        .post('/contents', {
          filters: [
            {
              comparator: COMPARATOR_TYPES.CONTAINS,
              name: 'id',
              value: contentIds,
            },
          ],
        })
        .then((d) => mapApiSearchContentResultsFromApiToVm(d.data.results)),
    {
      enabled: !!contentIds.length,
      retry: 0,
    },
  );
};
